import { render } from "./Idea.vue?vue&type=template&id=09b91e56&scoped=true"
import script from "./Idea.vue?vue&type=script&lang=js"
export * from "./Idea.vue?vue&type=script&lang=js"

import "./Idea.vue?vue&type=style&index=0&id=09b91e56&scoped=true&lang=less"

import exportComponent from "D:\\project\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b91e56"]])

export default __exports__